import { FaHandPointUp, FaPray, FaHandHoldingUsd, FaKaaba } from 'react-icons/fa';
import { BsMoonFill } from 'react-icons/bs';

const pillars = [
    {  
        id: 1,
        icon: <FaHandPointUp />,
        title: 'shahadah',
        content: 'The declaration of faith, affirming that there is no god but Allah and Muhammad is His Messenger.',
    },
    {
        id: 2,
        icon: <FaPray />,
        title: 'prayer',
        content: 'Performing the five daily prayers to connect with Allah and maintain spiritual discipline.',
    },
    {
        id: 3,
        icon: <BsMoonFill />,
        title: 'fasting',
        content: 'Observing the fast during the month of Ramadan as an act of worship and self-control.',
    },
    {
        id: 4,
        icon: <FaHandHoldingUsd />,
        title: 'zakat',
        content: 'Giving a portion of one’s wealth to those in need to purify wealth and support the community.',
    },
    {
        id: 5,
        icon: <FaKaaba />,
        title: 'hajj',
        content: 'Undertaking the pilgrimage to Makkah at least once in a lifetime if physically and financially able.',
    },
];

export default pillars;